export default __webpack_public_path__ + "static/media/search_button.a963f3db.svg";